import React, { useEffect, useRef } from "react"
import { graphql } from "gatsby"
import {Asset } from "../../../../plugins/gatsby-plugin-atollon"
import StructuredText from "../custom-structured-text-renderer"
import parse from "html-react-parser"

const FeatureInfoBlock = ({ title, richContent, image, subtitle }) => {


  return (
    <section className="feature-info-block" >
      <div className="feature-info-block__inner">
        <div className="feature-info-block__wrapper">
          <div className="line line--vertical center-top"></div>

          <div className="feature-info-block__top">
            <div className="feature-info-block__tagline">
              {subtitle && <span>{parse(subtitle)}</span>}
            </div>
            <div className="feature-info-block__title">
              {title && <h2>{parse(title)}</h2>}
            </div>
          </div>

          <div className="feature-info-block__bottom">
            {richContent && <div className="feature-info-block__content"><StructuredText data={richContent} /></div>}
            {image && <div className="feature-info-block__image"><Asset asset={image} /></div>}
          </div>
        </div>
      </div>
    </section>
  )
}
export default FeatureInfoBlock

export const query = graphql`
fragment FeatureInfoBlockProps on DatoCmsFeatureInfoBlock {
  ... on DatoCmsFeatureInfoBlock {
    id
    subtitle
    richContent {
      value
    }
    image {
      ...InternalAssetProps
    }
    title
  }
}
`